import { render } from "./DashboardMetrics.vue?vue&type=template&id=084ffd78&scoped=true"
import script from "./DashboardMetrics.vue?vue&type=script&lang=js"
export * from "./DashboardMetrics.vue?vue&type=script&lang=js"

import "./DashboardMetrics.vue?vue&type=style&index=0&id=084ffd78&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084ffd78"]])

export default __exports__